import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * Returns the current Caracas wall-clock time as an ISO 8601 string with a
 * fixed UTC-04:00 offset, e.g. "2026-07-14T12:00:00.000-04:00".
 */
export const getVenezuelaDate = (): string =>
	dayjs().tz("America/Caracas").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
